import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dot-v3",
  "use": "icon-dot-v3-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-dot-v3\"><circle cx=\"4.021\" cy=\"4\" r=\"3\" fill=\"#5073D8\" stroke=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol